import script from "./MonthYearSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthYearSelector.vue?vue&type=script&setup=true&lang=js"

import "./MonthYearSelector.vue?vue&type=style&index=0&id=271b5e04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271b5e04"]])

export default __exports__